import axios from 'axios';
import { debug } from 'console';
import { format, subMonths, startOfMonth, endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';

interface MonthlyData {
  name: string;
  Total: number;
}
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4020';
export class ChartServiceApi {
  private static baseURL = API_URL;
  private static cachedData: MonthlyData[] | null = null;
  private static lastFetch: Date | null = null;

  private static async fetchVentas() {
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos
    const now = new Date();

    if (this.cachedData && this.lastFetch &&
      (now.getTime() - this.lastFetch.getTime()) < CACHE_DURATION) {
      return this.cachedData;
    }

    try {
      const today = new Date();
      const lastThreeMonths: MonthlyData[] = [];

      // Obtener datos de los últimos 3 meses
      const ventasResponse = await axios.post(`${this.baseURL}/ventas/obtener-todas`);
      const ventas = ventasResponse.data;

      for (let i = 0; i < 3; i++) {
        const currentMonth = subMonths(today, i);
        const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(currentMonth);

        // Contar ventas finalizadas del mes
        const ventasDelMes = ventas.filter((v: any) => {
          const fechaVenta = new Date(v.informacionVenta.fechaVenta);
          return v.informacionVenta.estadoVenta === 4 && // Solo ventas finalizadas
            fechaVenta >= monthStart &&
            fechaVenta <= monthEnd;
        }).length;

        lastThreeMonths.unshift({
          name: format(currentMonth, 'MMMM', { locale: es }),
          Total: ventasDelMes
        });
      }

      this.cachedData = lastThreeMonths;
      this.lastFetch = now;

      return lastThreeMonths;
    } catch (error) {
      console.error('Error fetching ventas data:', error);
      return [];
    }
  }

  static async getMonthlyData(): Promise<MonthlyData[]> {
    try {
      return await this.fetchVentas();
    } catch (error) {
      console.error('Error getting monthly data:', error);
      return [];
    }
  }
}